// src/features/maps/Maps.js
import React from 'react';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import { googleMapsApiKey } from "../../App";

const libraries = ['places'];

const mapContainerStyle = {
  height: "263px",
  width: "728px",
  borderRadius: '15px'
};

const center = { lat: 33.734457, lng: 73.045045 };

export const Maps = ({ cameras }) => {
  console.log("Map component - Cameras:", cameras);
  
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: googleMapsApiKey,
    libraries,
    version: 'weekly', // Add version to avoid warnings
  });

  if (loadError) {
    console.error("Error loading Google Maps:", loadError);
    return (
      <div style={{
        height: "300px", 
        width: '100%', 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f0f0f0',
        borderRadius: '15px'
      }}>
        <div>Error loading maps. Please check your connection.</div>
      </div>
    );
  }

  if (!isLoaded) {
    console.log("Google Maps loading...");
    return (
      <div style={{
        height: "300px", 
        width: '100%', 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f0f0f0',
        borderRadius: '15px'
      }}>
        <div>Loading maps...</div>
      </div>
    );
  }

  console.log("Google Maps loaded, rendering map...");

  return (
    <div id="map" style={{
      height: "300px", 
      width: '100%', 
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={5}
        center={center}
        options={{
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: true,
        }}
      >
        {cameras && cameras.map((cam, index) => {
          // Parse coordinates safely
          const lat = parseFloat(cam.latitude);
          const lng = parseFloat(cam.longitude);
          
          // Only render marker if coordinates are valid
          if (!isNaN(lat) && !isNaN(lng)) {
            return (
              <Marker 
                key={`marker-${cam.id || index}`}
                position={{ lat, lng }}
                title={cam.description || `Camera ${cam.id}`}
                label={{
                  text: String(cam.id || index + 1),
                  color: "white",
                  fontSize: "12px",
                  fontWeight: "bold"
                }}
              />
            );
          }
          return null;
        })}
      </GoogleMap>
    </div>
  );
};